import React from 'react';
import './Support.css';

const Support = () => {
  return (
    <div className="support-container">
      <h1>Support</h1>
      <p>Need help? Our support team is here for you. Check out the resources below or reach out directly.</p>
      <ul>
        <li><strong>FAQs:</strong> Visit our <a href="/faq" className="support-link">FAQ page</a> for answers to common questions.</li>
        <li><strong>Email Support:</strong> Email us at <a href="mailto:support@cleancodeeng.com" className="support-link">support@cleancodeeng.com</a></li>
      </ul>
      <h2>Contact Support</h2>
      <p>For urgent issues, please use the contact form on our <a href="/contact" className="support-link">Contact page</a>.</p>
    </div>
  );
};

export default Support;
